"use strict";
import { OptionItem } from "components/lists/items/OptionItem";
import { WalletOptionItemContextMenu } from "components/lists/items/wallets/WalletOptionItemContextMenu";
import { useBooleanState } from "utilities/src/react/useBooleanState";
export function WalletBaseOptionItem({ option, ...optionItemProps }) {
  const { value: isContextMenuOpen, setFalse: closeContextMenu, setTrue: openContextMenu } = useBooleanState(false);
  const { address, type } = option;
  return <WalletOptionItemContextMenu address={address} isOpen={isContextMenuOpen} closeMenu={closeContextMenu}>
      <OptionItem testID={`wallet-item-${type}-${address}`} onLongPress={openContextMenu} {...optionItemProps} />
    </WalletOptionItemContextMenu>;
}
